export default __webpack_public_path__ + "static/media/black-logo.09eb4df0.svg";